// extracted by mini-css-extract-plugin
export default {"projectBlock":"Projects_projectBlock__mZcve","projectContainer":"Projects_projectContainer__AEIX3","projects":"Projects_projects__vjilC"};